/* eslint-disable no-use-before-define */
import React from "react";
import SearchIcon from '@material-ui/icons/Search';
import "./Search.css";
import IconButton from '@material-ui/core/IconButton';
export default function FreeSolo() {
  return (
    <div >
      {/* <input type="text" list="datalist" onkeyup="ac(this.value)" /> */}

      <div>
        <input   id="search-container" type="text" list="datalist" placeholder="Search"  onkeyup="ac(this.value)" name="search" />
        <IconButton aria-label="search" color="inherit">
            <SearchIcon onClick={search}  />
          </IconButton>
      </div>
      <datalist id="datalist" >
        <option value="CSE 3rd Sem Notes"></option>
        <option value="CSE 4th Sem Notes"></option>
        <option value="CSE 5th Sem Notes"></option>
        <option value="CSE 6th Sem Notes"></option>
        <option value="CSE 7th Sem Notes"></option>
        <option value="CSE 8th Sem Notes"></option>
        <option value="CSE 3rd Sem Question Bank"></option>
        <option value="CSE 4th Sem Question Bank"></option>
        <option value="CSE 5th Sem Question Bank"></option>
        <option value="CSE 6th Sem Question Bank"></option>
        <option value="CSE 7th Sem Question Bank"></option>
        <option value="CSE 8th Sem Question Bank"></option>
        <option value="CSE 5th Sem Projects"></option>
        <option value="CSE 6th Sem Projects"></option>
        {/* <option value="CSE 7th Sem Projects"></option>
        <option value="CSE 8th Sem Projects"></option> */}
           <option value="Buy Projects"></option>
      </datalist>
    </div>
  );
}

function search(){
  let n = document.getElementById("search-container").value;
  
  // notes from here
  if(n === "CSE 3rd Sem Notes"){
    window.location.href = "https://viewnotes.in/#/3rdSemNotes";
  }
  if(n === "CSE 4th Sem Notes"){
    window.location.href = "https://viewnotes.in/#/4thSemNotes";
  }
  if(n === "CSE 5th Sem Notes"){
    window.location.href = "https://viewnotes.in/#/5thSemNotes";
  }
  if(n === "CSE 6th Sem Notes"){
    window.location.href = "https://viewnotes.in/#/6thSemNotes";
  }
  if(n === "CSE 7th Sem Notes"){
    window.location.href = "https://viewnotes.in/#/7thSemNotes";
  }
  if(n === "CSE 8th Sem Notes"){
    window.location.href = "https://viewnotes.in/#/8thSemNotes";
  }
  // question bank from here
  if(n === "CSE 3rd Sem Question Bank"){
    window.location.href = "https://viewnotes.in/#/3rdSemQuestionBank";
  }
  if(n === "CSE 4th Sem Question Bank"){
    window.location.href = "https://viewnotes.in/#/4thSemQuestionBank";
  }
  if(n === "CSE 5th Sem Question Bank"){
    window.location.href = "https://viewnotes.in/#/5thSemQuestionBank";
  }
  if(n === "CSE 6th Sem Question Bank"){
    window.location.href = "https://viewnotes.in/#/6thSemQuestionBank";
  }
  if(n === "CSE 7th Sem Question Bank"){
    window.location.href = "https://viewnotes.in/#/7thSemQuestionBank";
  }
  if(n === "CSE 8th Sem Question Bank"){
    window.location.href = "https://viewnotes.in/#/8thSemQuestionBank";
  }

  // projects from here
  if(n === "CSE 5th Sem Projects"){
    window.location.href = "https://viewnotes.in/#/5thSemProject";
  }
  if(n === "CSE 6th Sem Projects"){
    window.location.href = "https://viewnotes.in/#/6thSemProject";
  }
  if(n === "Buy Projects"){
    window.location.href = "https://viewnotes.in/#/Buyprojects";
  }
  // if(n === "CSE 7th Sem Projects"){
  //   window.location.href = "https://betaviewnotes.netlify.com/#/7thSemProject";
  // }
  // if(n === "CSE 8th Sem Projects"){
  //   window.location.href = "https://betaviewnotes.netlify.com/#/q8th";
  // }
}